<template>
  <v-btn
    rounded
    :block="fullWidth"
    :color="color"
    :class="elevationClass"
    @click="e => $emit('click', e)"
    v-bind="$attrs"
  >
    <v-icon left v-if="icon">{{ icon }}</v-icon><slot/>
  </v-btn>
</template>

<script>
export default {
  name: 'round-button',
  props: {
    icon: {
      type: String,
      default: null,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'white',
    },
    elevation: {
      type: [Number, String, null],
      default: 0,
    },
  },
  computed: {
    elevationClass() {
      if (this.elevation === null) {
        return '';
      }
      return `elevation-${this.elevation}`;
    },
  },
};
</script>

<style lang="sass" scoped>
.v-btn.v-btn--rounded
  height: 36px
</style>
